import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=3cee3940&scoped=true"
import script from "./IconButton.vue?vue&type=script&lang=js"
export * from "./IconButton.vue?vue&type=script&lang=js"
import style0 from "./IconButton.vue?vue&type=style&index=0&id=3cee3940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cee3940",
  null
  
)

export default component.exports